import React from 'react'
import { connect } from 'react-redux'
import { dataTypes, bindingTypes } from '@adalo/constants'
import { Field } from 'redux-form'
import classNames from 'classnames'
import { WrappedBindableTextControl } from 'components/Shared/BindableTextControl'

import { getLabel } from '../../../../utils/sources'
import { getSources, addBindings } from '../../../../ducks/recommender'
import { getDefaultDatasource } from '../../../../ducks/apps/datasources'

const CancelScheduledNotifications = ({
  appId,
  componentId,
  objectId,
  actionId,
  field,
  userOptions,
  getLabel,
  reference,
  options,
  menuTheme,
  ...props
}) => {
  return (
    <div
      className={classNames(
        'action-item-form-options',
        'form-inspect-field-wrapper',
        'notifications-action-form'
      )}
    >
      <Field
        label="Notification ID"
        name={`${field}.options.notificationId`}
        component={WrappedBindableTextControl}
        objectId={objectId}
        reference={reference}
        actionId={actionId}
      />
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const { appId, componentId, objectId, actionId, reference } = props
  const datasource = getDefaultDatasource(state, appId)
  const { auth } = datasource
  const tableId = auth.table

  const userTypes = [
    { tableId, datasourceId: datasource.id, type: dataTypes.OBJECT },
    { tableId, datasourceId: datasource.id, type: dataTypes.LIST },
  ]

  const userOptions = addBindings(
    getSources(
      state,
      appId,
      componentId,
      objectId,
      userTypes,
      false,
      actionId,
      reference
    ),
    [bindingTypes.LIBRARY_PROP]
  )

  return {
    userOptions,
    getLabel: source => getLabel(state, source, appId, componentId),
  }
}

export default connect(mapStateToProps)(CancelScheduledNotifications)
